// A small, dismissible banner shown when a new app version has been installed
// and is waiting. Calling `onReload` triggers the actual update + reload.
export function showUpdatePrompt(onReload: () => void): void {
  // Never stack more than one prompt.
  if (document.querySelector(".update-prompt")) return;

  const prompt = document.createElement("div");
  prompt.className = "update-prompt";
  prompt.setAttribute("role", "alert");

  const text = document.createElement("span");
  text.className = "update-prompt-text";
  text.textContent = "A new version is available.";

  const reload = document.createElement("button");
  reload.type = "button";
  reload.className = "update-prompt-reload";
  reload.textContent = "Reload";
  reload.addEventListener("click", onReload);

  const dismiss = document.createElement("button");
  dismiss.type = "button";
  dismiss.className = "update-prompt-dismiss";
  dismiss.setAttribute("aria-label", "Dismiss");
  dismiss.textContent = "×"; // ×
  dismiss.addEventListener("click", () => prompt.remove());

  prompt.append(text, reload, dismiss);
  document.body.appendChild(prompt);
}
